module.exports = "<p>\r\n  chart works!\r\n</p>\r\n"